module.exports = __webpack_public_path__ + "src/assets/img/illustrations/suggestion-card-set-up-team_2X.94e1f7b6911fdcdfeb463d3f1df4c845.gif";